import {
  POST_DATA_STORE,
  SHOW_STORE_MODAL,
} from 'actions/AddOrEditStore/actionTypes';

const initialState = {
  postStoreLoading: false,
  isShowModalStore: false,
  dataPost: {},
};

const postDataStore = (state, action) => ({
  ...state,
  postStoreLoading: true,
});

const showModalStore = (state, action) => {
  return {
    ...state,
    isShowModalStore: !state.isShowModalStore,
    dataPost: action.data,
  };
};
const addOrEditStoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_DATA_STORE:
      return postDataStore(state, action);
    case SHOW_STORE_MODAL:
      return showModalStore(state, action);
    default:
      return state;
  }
};

export default addOrEditStoreReducer;
